.footer {
  display: flex;
  flex-direction: column;
  padding: 0 13px 13px;
}
